import PropTypes from "prop-types";

/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from "react";

import _ from "underscore";

import classNames from "classnames";

export default class OptionList extends React.Component {
  static displayName = "OptionList";

  static propTypes = {
    options: PropTypes.array,
  }; //{label: string, href: string (optional) key: string, disabled: bool}

  static defaultProps = { options: [] };

  handleClick = (option) => {
    if (!option.disabled) {
      if (option.href) {
        return (window.location = option.href);
      } else {
        return typeof this.props.onClick === "function" ? this.props.onClick(e) : undefined;
      }
    }
  };

  render() {
    return (
      <div className="et--options-list">
        {_.map(this.props.options, (option) => {
          return (
            <div
              className={classNames("et--options-list--option", option.disabled ? "is-disabled" : undefined)}
              onClick={() => this.handleClick(option)}
              key={option.key}
            >
              <a className="et--options-list--option-link">{option.label}</a>
            </div>
          );
        })}
      </div>
    );
  }
}
